<template>
  <div class="checkbox-filter">
    <div v-if="!loading && multiple" class="checkbox-filter__search-bar">
      <Input
        v-if="items.length > 10"
        :placeholder="`${$lang.search_a} ${pathOr('', ['caption'], item)}`"
        :value="form.searchText"
        name="searchText"
        id="searchText"
        type="text"
        rowClass="padding-x-16"
        rightIcon="magnify"
        :hasEraseIcon="!!this.form.searchText"
        :vuelidateObj="$v.form.searchText"
        @input="input"
        @erase="eraseSearchText"
      />
      <collapse-transition>
        <div v-if="selectedItemsCount" class="checkbox-filter__counter">
          <span class="checkbox-filter__indeterminate" @click="resetAll"></span>
          <span class="checkbox-filter__count">
            {{ `${selectedItemsCount} ${$lang.selected_case}` }}
          </span>
        </div>
      </collapse-transition>
    </div>
    <CheckboxFilterLoading :loading="loading" :multiple="multiple">
      <template #default>
        <ul class="checkbox-filter__items padding-top-16">
          <li v-for="(item, index) in filteredItems" :key="`a-${index}`">
            <label
              class="checkbox-filter__item"
              :class="multiple ? 'flex-start-start' : 'flex-start'"
            >
              <b-form-checkbox
                v-if="multiple"
                v-model="item.selected"
                size="lg"
              />
              <b-form-checkbox
                v-else
                v-model="item.selected"
                size="lg"
                class="custom-radio new-custom-radio"
                @change.native="selectRadio(item)"
              />
              <span class="checkbox-filter__item-text">
                {{ pathOr("", ["caption"], item) }}
              </span>
            </label>
          </li>
        </ul>
      </template>
    </CheckboxFilterLoading>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Input } from "@/components/re-design/forms";
import CheckboxFilterLoading from "./loading/CheckboxFilterLoading.vue";
import { pathOr, includes, is } from "ramda";
import { getFilterItems } from "@/services";
import { renderEumOptions } from "@/shared/utils";

export default {
  mixins: [inputMixin],
  components: { Input, CheckboxFilterLoading },
  props: {
    item: {
      type: Object,
      default: null,
    },
    selectedFilter: {
      type: [Array, Number, String],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      form: {
        searchText: {},
      },
    };
  },
  data() {
    return {
      form: {
        searchText: null,
      },
      loading: false,
      items: [],
    };
  },
  computed: {
    filteredItems() {
      // search in items
      const searchText = this.form.searchText;
      const checkLength = this.items.length > 10;
      if (!this.items.length) return [];
      const items =
        searchText && checkLength
          ? this.items.filter((item) => includes(searchText, item.caption))
          : this.items;

      return items;
    },
    selectedItemsCount() {
      return this.filteredItems.filter((item) => item.selected).length;
    },
  },
  watch: {
    item: {
      // get all items when filter item is prepared
      immediate: true,
      handler(value) {
        value && this.getItems();
      },
    },
    items: {
      // generate checkbox selected items
      deep: true,
      handler() {
        this.multiple && this.generateServiceData();
      },
    },
  },
  methods: {
    pathOr,
    includes,
    renderEumOptions,
    async getItems() {
      try {
        this.loading = true;
        const { isEnum, moduleName, name, params } = this.item;
        let items = [];

        if (isEnum) {
          items = renderEumOptions(name, true);
        } else {
          const response = await getFilterItems(moduleName, name, params);
          items = pathOr([], ["items"], response);
        }

        this.items = items;
        this.generateSelectedItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    eraseSearchText() {
      this.form.searchText = null;
    },
    resetAll() {
      this.items = this.items.map((item) => {
        return {
          ...item,
          selected: false,
        };
      });
    },
    selectRadio(getItem) {
      // select current item and unselect other items
      this.items = this.items.map((item) => {
        const selected = getItem.id === item.id;
        return {
          ...item,
          selected,
        };
      });
      this.generateServiceData();
    },
    generateServiceData() {
      let data = this.multiple
        ? this.items.filter((item) => item.selected)
        : this.items.find((item) => item.selected);

      data = this.multiple
        ? data.map((item) => item.id)
        : pathOr(null, ["id"], data);
      this.$emit("getFilterData", this.item, data);
    },
    generateSelectedItems() {
      const { selectedFilter } = this;
      this.items = this.items.map((item) => {
        let selected = false;
        if (this.multiple) {
          const selectedItems = selectedFilter.map((row) => +row || row);
          selected = includes(item.id, selectedItems);
        } else {
          const selectedItem = +selectedFilter || selectedFilter;
          selected = item.id === selectedItem;
        }
        return {
          ...item,
          selected,
        };
      });
    },
  },
};
</script>
